<template>
  <div class="detail">
    <myDialog :logTitle="'调解详情'" :showDialog.sync="open">
      <el-button type="primary" class="close" icon="el-icon-circle-close" size="medium" @click="close"/>
      <div class="main-content">
        <div class="recordInfo" v-if="recordInfo">
          <div class="title">调解申请信息</div>
          <el-row :gutter="10">
            <el-col :span="6">
              <div class="label">案件编号:</div>
              <span>{{ recordInfo.recordId }}</span>
            </el-col>
            <el-col :span="4">
              <div class="label">调解类型:</div>
              <span>{{ dictMap.mediation_type[recordInfo.mediationType] }}</span>
            </el-col>
            <el-col :span="4">
              <div class="label">调解方式:</div>
              <span>{{ dictMap.mediation_category[recordInfo.mediationCategory] }}</span>
            </el-col>
            <el-col :span="4">
              <div class="label">调解状态:</div>
              <span>{{ dictMap.mediation_status[recordInfo.status] }}</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <div class="label">纠纷描述:</div>
              <span>{{ recordInfo.disputeDesc }}</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <div class="label">纠纷诉求:</div>
              <span>{{ recordInfo.applicantReq }}</span>
            </el-col>
          </el-row>
        </div>
        <div class="accidentInfo" v-if="accidentInfo">
          <div class="title">事故信息</div>
          <el-row :gutter="10">
            <el-col :span="6">
              <div class="label">事故时间:</div>
              <span>{{ accidentInfo.accidentTime }}</span>
            </el-col>
            <el-col :span="6">
              <div class="label">事故责任认定书:</div>
              <a target="_blank" :href="accidentInfo.liabilityUrl">点击查看</a>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <div class="label">事故地点:</div>
              <span>{{ accidentInfo.accidentAddress }}</span>
            </el-col>
          </el-row>
        </div>
        <div class="personInfos" v-if="personInfos">
          <div class="title">当事人信息</div>
          <el-table :data="personInfos" style="width: 100%">
            <el-table-column prop="name" label="姓名" align="center" width="100"/>
            <el-table-column prop="category" label="当事人类型" align="center" width="100">
              <template v-slot="scope">
                <span v-if="scope.row.category === '0'">申请人</span>
                <span v-else>被申请人</span>
              </template>
            </el-table-column>
            <el-table-column prop="personType" label="类型" align="center" width="100">
              <template v-slot="scope">
                <span v-if="scope.row.personType === '0'">自然人</span>
                <span v-else-if="scope.row.personType === '1'">法人</span>
                <span v-else-if="scope.row.personType === '2'">其他组织</span>
                <span v-else>其他</span>
              </template>
            </el-table-column>
            <el-table-column prop="phone" label="电话" align="center" width="110"/>
            <el-table-column prop="gender" label="性别" align="center" width="50">
              <template v-slot="scope">
                <span v-if="scope.row.gender === '0'">男</span>
                <span v-else>女</span>
              </template>
            </el-table-column>
            <el-table-column prop="idType" label="证件类型" align="center" width="100">
              <template v-slot="scope">
                <span v-if="scope.row.idType === '0'">身份证</span>
                <span v-else-if="scope.row.idType === '1'">临时身份证</span>
                <span v-else-if="scope.row.idType === '2'">户口簿</span>
                <span v-else-if="scope.row.idType === '3'">军官证</span>
                <span v-else-if="scope.row.idType === '4'">警官证</span>
                <span v-else-if="scope.row.idType === '5'">港澳通行证</span>
                <span v-else>其他</span>
              </template>
            </el-table-column>
            <el-table-column prop="idNum" label="证件号" align="center" width="250"/>
          </el-table>
        </div>
        <div class="mediatedResult" v-if="mediatedResult">
          <div class="title">调解结果</div>
          <el-row>
            <el-col :span="24">
              <div class="label">调解结果:</div>
              <el-select v-model="mediatedResult.mediationResult" prop="mediationResult" style="width: 200px">
                <el-option v-for="item in mediationResultList" :key="item.value" :label="item.label"
                           :value="item.value"/>
              </el-select>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <div class="label">履行方式:</div>
              <el-select v-model="mediatedResult.performanceMode" prop="performanceMode" style="width: 200px">
                <el-option v-for="item in performanceModeList" :key="item.value" :label="item.label"
                           :value="item.value"/>
              </el-select>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <div class="label">协议日期:</div>
              <el-input suffix-icon="el-icon-date" v-model="mediatedResult.agreeDate" readonly style="width: 200px"/>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <div class="label">涉案金额:</div>
              <el-input type="number" suffix-icon="el-icon-coin" v-model="mediatedResult.amount" readonly
                        style="width: 200px"/>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="2.5">
              <div class="label">协议内容:</div>
            </el-col>
            <el-col :span="10">
              <el-input type="textarea" :rows="10" v-model="mediatedResult.agreeContext"
                        :autosize="{ minRows: 4, maxRows: 15}" readonly/>
            </el-col>
          </el-row>
        </div>
      </div>
    </myDialog>
  </div>
</template>

<script>
import myDialog from '@/components/custom/myDialog.vue'

export default {
  name: 'MediationDetail',
  components: {myDialog},
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    dictMap: {
      type: Object,
      default: () => {
      }
    },
    recordInfo: {
      type: Object,
      default: () => {
      }
    },
    accidentInfo: {
      type: Object,
      default: () => {
      }
    },
    personInfos: {
      type: Array,
      default: () => {
      }
    },
    mediatedResult: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    return {
      mediationResultList: [
        {
          label: '调解成功',
          value: '0',
        },
        {
          label: '调解不成功',
          value: '1',
        }
      ],
      performanceModeList: [
        {
          label: '一次性赔偿',
          value: '0',
        },
        {
          label: '分期支付',
          value: '1',
        }
      ],
    }
  },
  created() {

  },
  methods: {
    close() {
      this.$emit('close', false);
    }
  }
}
</script>

<style lang="scss">
.detail {
  width: 100%;

  .close {
    position: absolute;
    top: 10px;
    right: 10px;
    background-color: #0F1F46;
  }

  .close:hover {
    background-color: #0F1F46;
  }

  .logContent {
    width: 80%;
  }

  .main-content {
    color: rgb(177, 227, 255);
    padding-left: 10px;
    padding-right: 10px;

    .recordInfo,
    .accidentInfo,
    .personInfos,
    .mediatedResult {
      margin-bottom: 15px;

      .title {
        margin-bottom: 10px;
        font-size: 20px;
        font-weight: 700;
      }

      .el-row {
        margin-top: 10px !important;
      }

      .label {
        display: inline-block;
        margin-right: 5px;
      }

      span {
        margin-left: 10px;
        color: #FFFFFF;
      }

      a {
        margin-left: 10px;
        color: #00afff
      }
    }

    .recordInfo {

    }

    .accidentInfo {
    }

    .personInfos {
    }

    .mediatedResult {

    }
  }

  .el-textarea__inner {
    border-color: #0278C6;
    background-color: #0F1F46;
    color: #b1e3ff;
  }
}

</style>>
